<template>
    <modal name="chooseAssistantsModal" width="50%" height="95%">
        <div class="p-2">
            <v-btn
                class="big-close-btn"
                fab
                color="#ececd8"
                @click="closeModal"
            >
                <v-icon
                    aria-label="Close"
                    large
                >
                    mdi-close
                </v-icon>
            </v-btn>
            <h2 class="text-center">Выберите помощников в смену:</h2>
            <div class="button-wrapper">
                <v-item-group
                    v-model="assistants"
                    multiple
                    class="mx-auto"
                >
                    <v-row class="mx-8">
                        <v-col
                            v-for="(item, index) in filtredAssistants"
                            :key="item.assistantId"
                            :class="islastodd(index)?'col-6 mx-auto':''"
                        >
                        <v-item v-slot="{ active, toggle }" :value="item.assistantId">
                            <v-card
                                class="mx-4"
                                max-width="644"
                                :color="active ? '#fffbcd' : ''"
                                @click="toggle"
                            >
                                <v-list-item>
                                    <v-list-item-avatar
                                        size="80"
                                        color="grey"
                                    >
                                        <v-icon dark size="80">
                                            mdi-account-circle
                                        </v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title class="headline mb-1">
                                            {{item.name}}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>Мастер 1 класса<br/></v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>
                        </v-item>
                        </v-col>
                    </v-row>
                </v-item-group>
                <!--div class="pl-2 pt-4"  v-for="availableAssistant in availableAssistants">
                    <input type="checkbox" :id="'ass-' + availableAssistant.assistantId" :name="'ass-' + availableAssistant.assistantId" :value="availableAssistant.assistantId" v-model="assistants">
                    <label :for="'ass-' + availableAssistant.assistantId">
                        <div class="btn btn-options__checkbox">
                        <img class="rounded-circle z-depth-2 w-100" :src="'https://eu.ui-avatars.com/api/?name=' + availableAssistant.name"/>
                        <br/>
                        <span class="d-block pt-2">{{ availableAssistant.name }}</span>
                        </div>
                    </label>
                </div-->
            </div>
            <div class="button-selected">
                <button type="button" class="btn btn-primary ml-auto mr-auto" @click="addAssistants">Добавить</button>
            </div>
        </div>
    </modal>
</template>

<script>
import axios from "../../plugins/axios-common";
import {mapGetters} from 'vuex'

export default {
    props: {
        order: {
            type: Boolean,
            default: false
        },
        shiftId: {
            type: Number
        },
        payment: {
            type: Boolean,
            default: false
        }
    },
    data() {
            return {
                ass: [],
                selected: '',
                availableAssistants: {},
                assistants: [],
                error: '',
                loading: true
            }
    },
    computed: {
        ...mapGetters('shift', [
            "shiftAssistants",
        ]),
        filtredAssistants() {
            return this.availableAssistants.length > 0 ? this.availableAssistants.filter(item => !this.shiftAssistants.includes(item.assistantId)) : []
        }
    },
    async mounted() {
        this.fetchWorkshopAvailableAssistants()
    },
    methods: {
        closeModal () {
            this.$modal.hide('chooseEmployeesModal')
        },
        islastodd(index){
            return this.availableEmployees && this.availableEmployees.length - 1  === index && this.availableEmployees.length % 2 !== 0
        },
        fetchWorkshopAvailableAssistants() {
          // todo вызов апи в стор
            axios
            .get('/api/cash/workshop/availableemployees')
            .then(response => {
                this.availableAssistants = response.data.data.assistants
            })
            .catch(error => {
                console.log(error)
                this.error = true
            })
            .finally(() => (this.loading = false))
        },
        addAssistants() {
            this.$store.dispatch('shift/addAssistants', { 'assistants': this.assistants}).then(() => {
              this.$modal.hide('chooseAssistantsModal')
              location.reload()
            })
        },
    }
}
</script>

<style scoped>
    .button-selected {
        margin-top: 30px;
        text-align: center;
    }
    .button-wrapper {
        display: flex;
        align-items: flex-start;
        justify-content: space-around;
        margin-top: 30px;
    }
    .big-close-btn {
        position: absolute;
        top: 6px;
        right: 6px;
    }

    input[type="radio"], input[type="checkbox"] {
        opacity: 0;
        position: fixed;
        width: 0;
    }

    .btn-options__checkbox {
        display: table-cell;
        padding: 10px;
        width: 5vw;
        height: 6vh;
        border-radius: 15px;
        background-color: #eee;
        vertical-align: middle;
    }

    .btn-options__checkbox:hover {
        box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15);
    }

    input[type="radio"]:focus + label, input[type="checkbox"]:checked  + label {
        border-radius: 15px;
    }

    input[type="radio"]:checked + label>div, input[type="checkbox"]:checked + label>div {
        background-color: #fffbcd;
        box-shadow: inset 1px 2px 4px 0 rgba(0, 0, 0, .4);
    }

    .btn-primary {
        padding: 10px 30px;
        background: linear-gradient(180deg, #C8FA92 0%, #B5E97C 50%);
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
        border-radius: 11px;
        font-size: 20px;
        color: #000;
    }
</style>
